// extracted by mini-css-extract-plugin
export default {"deleteModal":"DeleteModal_deleteModal__1y0c0","modalHeader":"DeleteModal_modalHeader__9zCao"};